<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="d.r.e.a.m.s.">
<h2>D.R.E.A.M.S.</h2>
<table style="width:99%;">
<colgroup>
<col width="10%"/>
<col width="95%"/>
</colgroup>
<thead>
<tr class="header">
<td align="left">Man1:</td>
<td align="left">What’s the matter?</td>
</tr>
</thead>
<tbody style="vertical-align: top;">
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">I had this horrible nightmare.</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">I thought all nightmares were horrible?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">I am not amused. And as I was saying…</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">Hmm.</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">As I was saying, I had this nightmare about an orange and yellow fish chasing me. Sometimes it would disappear then reappear in front of me.</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">Whoa! What did it look like again?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">Well it kinda’ looked like the giant fish kites that the Chinese use in their celebrations.</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">And THAT is what was chasing you?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">It was just a dream and as a matter of fact, it was my dream and I can dream anything I want. Nobody gave you a hard time about the dream that you had with Fay Wray and King Kong. Especially the part where you were hanging…</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">Okay, that’s enough. Point taken. Did it ever catch you?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">No! Like all dreams, it just ended with the fish cornering me.</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">Well, I can tell you what that means?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">And the Great Mesmo?</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">It means never go out with your shoes?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">What!</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">That’s right. You ran out last night to the Chinese restaurant and left one at home.</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">Yeah?</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">And what did you eat?</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">Oh, no! Fish. No punch line please!</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">Sorry. But Fay Wray and King Kong comments deserve a retort.</td>
</tr>
<tr class="odd">
<td align="left">Man2:</td>
<td align="left">Go ahead!</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">You left your SOLE at home and it was trying to catch up with you.</td>
</tr>
<tr class="odd">
<td align="left">Man2</td>
<td align="left">Wise guy! And you?</td>
</tr>
<tr class="even">
<td align="left">Man1:</td>
<td align="left">Water. I can swim.</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3b6900bb